import React from 'react';
import type { BuiltResume } from '../../../resume-engine/types';
import { ResumeHeader } from '../components/ResumeHeader';
import { ResumeSummary } from '../components/ResumeSummary';
import { EngineeringHighlights } from '../components/EngineeringHighlights';
import { TechnicalExpertise } from '../components/TechnicalExpertise';
import { ExperienceSection } from '../components/ExperienceSection';
import { ProjectsSection } from '../components/ProjectsSection';
import { SkillsSection } from '../components/SkillsSection';
import { EducationSection } from '../components/EducationSection';
import { CertificationSection } from '../components/CertificationSection';
import { ContactSection } from '../components/ContactSection';

interface Props {
  resume: BuiltResume;
}

export function ATSLayout({ resume }: Props) {
  return (
    <div className="resume-document resume-ats">
      <ResumeHeader contact={resume.contact} ats />
      <ResumeSummary summary={resume.summary} />
      <EngineeringHighlights highlights={resume.highlights} />
      <TechnicalExpertise expertise={resume.technicalExpertise} />
      <ExperienceSection experiences={resume.experiences} ats />
      <ProjectsSection projects={resume.projects} ats />
      <SkillsSection skills={resume.skills} />
      <EducationSection education={resume.education} />
      <CertificationSection certifications={resume.certifications} />
      <ContactSection contact={resume.contact} />
    </div>
  );
}
